export default __webpack_public_path__ + "static/media/beta-tumse.51637f88.jpg";